import { useCallback, useEffect, useState } from 'react'
import { useBoolean } from 'react-use'

import { NotificationsAPI } from '@makyoapp/makyo-sdk'
import { NotificationActionTrigger } from '@makyoapp/makyo-sdk/models/Notifications'
import {
  IOrganizationMemberInviteMetadata,
  IOrganizationTransferOwnershipMetadata,
} from '@makyoapp/makyo-sdk/models/NotificationsMetaData'
import { fromSdkNotification, NotificationItemAdapter } from '@makyoapp/makyo-common'

import { INVITATION_ACTION_KEY, INVITATION_DATA_KEY } from '@/shared/constants'

import useAuth from './useAuth'
import { useInvite } from './useInvite'

export function useReqNotif(theAction: NotificationActionTrigger) {
  const { userData } = useAuth()
  const { action, data: untypedData, searchParams, setSearchParams } = useInvite()
  const data = untypedData as IOrganizationMemberInviteMetadata | IOrganizationTransferOwnershipMetadata
  const [invitation, setInvitation] = useState<NotificationItemAdapter | undefined>(undefined)

  const [showNotMatch, setShowNotMatch] = useBoolean(false)
  const [show, setShow] = useBoolean(false)
  const [recall, setRecall] = useBoolean(true)
  const isOnBoarding = userData?.name === undefined || userData?.name.trim().length < 1

  const [isLoading, setIsLoading] = useBoolean(false)

  const onHide = useCallback(() => {
    setIsLoading(false)
    setShow(false)
    setShowNotMatch(false)
  }, [setShow, setShowNotMatch, setIsLoading])

  const onHideWithClean = useCallback(() => {
    onHide()
    searchParams.delete(INVITATION_ACTION_KEY)
    searchParams.delete(INVITATION_DATA_KEY)
    setSearchParams(searchParams)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onHide, setSearchParams])

  useEffect(() => {
    if (data?.NotificationID && invitation === undefined && action === theAction && recall) {
      NotificationsAPI.ReqGet(data.NotificationID)
        .then((res) => {
          setInvitation(fromSdkNotification(res))
          if (res._Receiver._id === userData?.id) {
            setShow(true)
            setShowNotMatch(false)
          } else {
            setShowNotMatch(true)
            setShow(false)
          }
        })
        .catch(() => {
          setRecall(false)
          setShowNotMatch(true)
        })
    }
  }, [theAction, data, invitation, setInvitation, setShow, setShowNotMatch, action, userData?.id, recall, setRecall])

  return {
    action,
    data,
    invitation,
    setInvitation,
    show,
    setShow,
    showNotMatch,
    setShowNotMatch,
    isLoading,
    setIsLoading,
    isOnBoarding,
    onHide,
    onHideWithClean,
  }
}
